export const WEDDING_DATE = new Date("April 21, 2024 17:00:00 GMT-0500");
//export const WEDDING_DATE = new Date("October 1, 2023 17:00:00 GMT-0500");